export const blogPosts = [
  {
    id: 1,
    title: "The Future of Computer Vision in Retail",
    excerpt: "Exploring how AI-powered visual recognition is transforming the shopping experience and reducing return rates.",
    author: "Dr. Arun Kumar",
    date: "2025-10-15",
    category: "Computer Vision",
    readTime: "5 min read",
    image: "https://images.unsplash.com/photo-1441986300917-64674bd600d8?w=800&q=80"
  },
  {
    id: 2,
    title: "Predictive Maintenance: The Industrial IoT Revolution",
    excerpt: "How smart sensors and AI are preventing equipment failures and optimizing manufacturing operations.",
    author: "Priya Mehta",
    date: "2025-10-01",
    category: "IoT",
    readTime: "7 min read",
    image: "https://images.unsplash.com/photo-1581091226825-a6a2a5aee158?w=800&q=80"
  },
  {
    id: 3,
    title: "Building AI-Ready Education Systems",
    excerpt: "The importance of integrating AI and robotics curriculum in schools to prepare students for the future.",
    author: "Sandeep Singh",
    date: "2025-09-20",
    category: "Education",
    readTime: "6 min read",
    image: "https://images.unsplash.com/photo-1503676260728-1c00da094a0b?w=800&q=80"
  },
  {
    id: 4,
    title: "Visual Search: The Next Generation of E-commerce",
    excerpt: "Understanding how image-based search is changing the way customers discover and shop for products online.",
    author: "Meera Patel",
    date: "2025-09-05",
    category: "AI",
    readTime: "5 min read",
    image: "https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=800&q=80"
  }
];

export const blogCategories = [
  "All",
  "Computer Vision",
  "AI",
  "IoT",
  "Education",
  "Technology"
];
